
import useWindowSize from "@components/_hooks/useWindowSize";
import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";

const mobilePaddingSubtitle = {
    paddingLeft: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    paddingRight: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    fontSize:28
}
const mobilePaddingDescription = {
    paddingLeft: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    paddingRight: {
        xs: '0.75rem',
        lg: '0.75rem'
    },
    fontSize:16,
    paddingBottom:1
}

const CategoryDescriptions = (props) => {
    const {
        subtitle,
        description,
        loading
    } = props;

    const {isMobile} = useWindowSize();
    
    return (
        !loading ? (
            <>
            <Typography 
                sx={mobilePaddingSubtitle} 
                component="h1" 
                // className="f-size_4"
                className="mb-1"
            >
                {subtitle}
            </Typography>
            <Typography 
                sx={mobilePaddingDescription} 
                component="p"
                className={`${isMobile && 'f-size_1'}`}
            >
                {description}
            </Typography>
            </>

        ) : (
            null
        )
    )
}

export default CategoryDescriptions